module.exports = __webpack_public_path__ + "img/sesamo.3148fed3.png";